import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LaguageService } from 'src/app/laguage.service';
import { ToastrService } from 'ngx-toastr';
import { PaymentService } from 'src/app/project-roles/super-admin/services/payments/payments.service';
import { MatDialog } from '@angular/material/dialog';
import { BranchesService } from 'src/app/project-roles/admin/services/branches/branches.service';
import { HCService } from 'src/app/project-roles/admin/services/health-care/hc.service';
import { CustomerBookingService } from 'src/app/project-roles/admin-content/services/booking/customer-booking.service';
declare var $: any;

@Component({
  selector: 'app-public-booking',
  templateUrl: './public-booking.component.html',
  styleUrls: ['./public-booking.component.scss'],
})
export class PublicBookingComponent implements OnInit {
  allHealthPrice: any[] = [];
  items: any[] = [];
  allSubservices: any[] = [];
  services: any[] = [];
  serviceDetails: any[] = [];
  newServices: any[] = [];
  availabilityService: any[] = [];
  Initiated: any[] = [];
  allBranches: any[] = [];
  allHealthcare: any[] = [];
  subSubServices: any[] = [];
  excuted: any = {};
  id: any;
  isLoading: boolean = false;
  inputShow: boolean = false;
  form: boolean = true;
  getpaid: boolean = false;
  disabledFields = true;
  serviceDisabled: boolean = true;
  error: boolean = false;
  err: boolean = false;
  isDisabledService: boolean = true;
  DisabledButton: boolean = true;
  availabelService: boolean = true;
  isDisabled: boolean = true;
  hide = true;
  selectedOption?: string;
  textName!: any;
  serviceSingle: any;
  getItem: any;
  getItemService: any;
  currentLang: any;
  getNewService: any;
  Newterms: any;
  availabeiltyService: any;
  serviceAvailability: any;
  priceValue: any;
  priceTotal: any;
  payment: any;
  getPaid: any;
  link: string = '';
  completePaid: boolean = false;
  Disabled: boolean = true;
  branchDisabled: boolean = true;
  phoneNumber: any;
  booking: any;
  itemId: any;
  branchId: any;
  selectedService: any;
  serviceAvailabilityid: any;
  hcId: any;
  selectedSubServiceId: any;
  branchID: any;
  selectedHealthCareId: number | null = null;
  selectedBranchId: number | null = null;
  price: number | null = null;

  constructor(
    private _services: CustomerBookingService,
    public dialog: MatDialog,
    private _lang: LaguageService,
    private _service: PaymentService,
    private toaster: ToastrService,
    private _branches: BranchesService,
    private hcServices: HCService
  ) {
    this.currentLang = this._lang.getValue();
  }

  getSelectedValue(event: any) {
    this.allSubservices.push(event.id);
  }

  ngOnInit(): void {
    this.getservice();
    if (this.currentLang.source._value == 'en') {
      this.textName = 'sub_servie_en_name';
    } else {
      this.textName = 'sub_servie_ar_name';
    }
  }

  bookingForm = new FormGroup({
    first_name: new FormControl(null, [Validators.required]),
    last_name: new FormControl(null, [Validators.required]),
    branch_id: new FormControl(null, [Validators.required]),
    phone_number: new FormControl(null, [
      Validators.required,
      Validators.pattern('[5][0-9]{8}'),
    ]),
    service_availability_id: new FormControl([], [Validators.required]),
    code: new FormControl(null),
  });

  getservice() {
    this._services.getServices().subscribe((data: any) => {
      this.services = data.data.rows;
    });
  }

  onChange(e: any) {
    if (this.serviceSingle === undefined) {
      this.isDisabled = false;
    }
  }

  submitoffersData(bookingForm: FormGroup) {
    this.isLoading = true;
    this.Disabled = true;
    this.bookingForm.controls['service_availability_id'].setValue(
      bookingForm.value.service_availability_id
    );
    this.bookingForm.controls['code'].setValue(this.codeForm.value.code);
    this._services.createPublicBooking(bookingForm.value).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.Disabled = false;
        this.completePaid = true;
        this.booking = response.data.booking_id;
        this.toaster.success(response.message);
        this.paid(event);
      },
      (err) => {
        this.Disabled = false;
        this.isLoading = false;
      }
    );
  }

  paid(event: any): void {
    this.form = false;
    this.getpaid = true;
    var paiding = {
      booking_id: this.booking,
    };

    this._service.initiatePayment(paiding).subscribe((res) => {
      this.Initiated = res.data.Data.PaymentMethods;
      this.getPaid = paiding.booking_id;
    });
  }

  getNewSubService(item: any): void {
    this.selectedService = item;
    this._services.getSubService(item).subscribe((response: any) => {
      this.newServices = response.data.rows;
    });
    this.getNewService = item;
  }

  getSubServicewithSub(item: any): void {
    this.selectedSubServiceId = item;
    this._services.getSubServiceWithSub(item).subscribe((response: any) => {
      this.serviceDetails = response?.data?.rows ?? response?.data ?? [];
      this.allBranches = [];
      this.branchDisabled = true;
    });
    this.getItem = item;
  }

  onHealthCareChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    const hcId = Number(target.value);
    this.selectedHealthCareId = hcId;

    const selectedHC = this.serviceDetails.find(
      (hc) => hc.health_care_id === hcId || hc.id === hcId
    );

    if (selectedHC?.branches?.length) {
      this.allBranches = selectedHC.branches;
      this.branchDisabled = false;
      this.serviceDisabled = true;
    } else {
      this.allBranches = [];
      this.branchDisabled = true;
      this.serviceDisabled = false;
    }

    if (hcId && !isNaN(hcId)) {
      this.getSubByHC(hcId);
    } else {
      this.subSubServices = [];
    }
  }

  onChangeBranch(event: Event) {
    const branchId = Number((event.target as HTMLSelectElement).value);
    this.selectedBranchId = branchId || null;

    if (branchId && this.selectedHealthCareId) {
      this.getSubByHC(this.selectedHealthCareId, branchId);
      this.getHCprice(branchId);
      this.serviceDisabled = false;
    } else {
      this.getSubByHC(this.selectedHealthCareId);
      this.serviceDisabled = false;
    }
  }

  getSubByHC(hcId: any, branchId?: any) {
    if (!this.selectedSubServiceId) {
      return;
    }

    this._services
      .GetSubServiceByHc(hcId, this.selectedSubServiceId, branchId ?? undefined)
      .subscribe((res: any) => {
        this.subSubServices = res?.data ?? [];
      });
  }

  getHCbySubService(item: any): void {
    this._services.getSubServiceWithSub(item).subscribe((response: any) => {
      this.allHealthcare = response.data;
    });
    this.getItemService = item;
  }

  onChangeService(e: any) {
    if (this.Newterms === undefined) {
      this.isDisabledService = false;
    }
  }

  getAvailabelService(e: any) {
    if (this.availabeiltyService === undefined) {
      this.availabelService = false;
    }
  }

  get formOffers() {
    return this.bookingForm.controls;
  }

  getId(itemId: any): void {
    let currentItem = this.subSubServices.find(
      (item) => item.service_availability_id == itemId
    );
    this.itemId = itemId;
    console.log(itemId);
  }

  getPrice(itemPrice: any): void {
    let currentItem = this.availabilityService.find(
      (item) => item.id == itemPrice
    );
  }

  codeForm = new FormGroup({
    code: new FormControl(null, [Validators.required]),
    service_availability_id: new FormControl(null, [Validators.required]),
    branch_id: new FormControl(null),
  });

  serviceAvailabilityId(item: any) {
    this.serviceAvailabilityid = item;
  }

  sendCode(codeForm: FormGroup) {
    this.codeForm.controls['branch_id'].setValue(this.selectedBranchId);
    this.codeForm.controls['service_availability_id'].setValue(
      this.serviceAvailabilityid
    );

    this._services.sendCode(codeForm.value).subscribe(
      (response: any) => {
        this.toaster.success('The code has been sent successfully');
        this.disabledFields = true;
        this.price = response.data.rows;
        this.price = response.data.rows.price;
        this.availabelService = true;
        this.itemId = '';
      },
      (err) => {
        this.disabledFields = false;
      }
    );
    if (codeForm.valid) {
      this.DisabledButton = false;
    } else {
      this.DisabledButton = true;
    }
  }

  focusField() {
    this.disabledFields = false;
    this.price = null;
  }

  resetForm() {
    this.bookingForm.reset();
    this.codeForm.reset();
    this.price = null;
  }

  onFocus(): void {
    this.error = false;
  }

  excutePaid(event: any, method: number): void {
    let paid = {
      booking_id: this.getPaid,
      paymentMethodId: method,
    };

    this._service.executePayment(paid).subscribe((res) => {
      this.link = res.data.Data.PaymentURL;
      this.excuted = res.data.Data;
      $('#exampleModal').modal('hide');
    });
  }

  newBooking() {
    this.form = true;
    this.getpaid = false;
    this.resetForm();
    this.completePaid = false;
  }

  getAllBranches(id: any) {
    this._branches.getHCBranchesDetails(id).subscribe({
      next: (data: any) => {
        this.allBranches = Array.isArray(data.data) ? data.data : [];
      },
      error: (err) => {
        this.allBranches = [];
      },
    });
  }

  getHCId(item: any) {
    this.hcId = item;
  }

  getIdBranch(item: any) {
    this.branchID = item;
  }

  getHCprice(item: any) {
    if (!this.selectedHealthCareId || !this.selectedSubServiceId) {
      return;
    }

    this._services
      .GetHealthCarePrice(this.selectedService, this.hcId, item || undefined)
      .subscribe((res: any) => {
        this.price = res?.data?.rows?.price ?? null;
      });
  }
}
